import { useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import { Option } from "@pages/Assistant/components/AssistantForm";
import { UploadedConversationFile } from "@services/ConversationFilesService";

export const useResetAssistant = ({
  resetSession,
  resetFeedbackState,
  setSelectedFiles,
  setCitations,
  setChatHistory,
  setQuestion,
  clearChat,
  setError,
  setLoadingStepData,
  setSocket,
  setSelectedProject,
  setSelectedReport,
  socket,
  setIsChatLoading,
  setLoading,
  setConversationId,
  conversationIdParam,
  fetchConversation,
  setEnabledSources,
  setUploadedFiles,
  setPendingFiles,
}: {
  resetSession: () => void;
  resetFeedbackState: () => void;
  setSelectedFiles: (val: any[]) => void;
  setCitations: (val: any[]) => void;
  setChatHistory: (val: any[]) => void;
  setQuestion: (val: string) => void;
  clearChat: () => void;
  setError: (val: string | null) => void;
  setLoadingStepData: (val: any) => void;
  setSocket: (val: WebSocket | null) => void;
  setSelectedProject: (val: Option) => void;
  setSelectedReport: (val: Option) => void;
  socket: WebSocket | null;
  setIsChatLoading: (val: boolean) => void;
  setLoading: (val: boolean) => void;
  setConversationId: (val: string) => void;
  conversationIdParam?: string;
  fetchConversation: (id: string) => Promise<void>;
  setEnabledSources: React.Dispatch<React.SetStateAction<Set<string>>>;
  setUploadedFiles: React.Dispatch<
    React.SetStateAction<UploadedConversationFile[]>
  >;
  setPendingFiles: React.Dispatch<
    React.SetStateAction<UploadedConversationFile[]>
  >;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const newChat = searchParams.get("new");

  const resetChat = () => {
    resetSession();
    resetFeedbackState();
    setCitations([]);
    setChatHistory([]);
    setQuestion("");
    clearChat();
    setError(null);
    setLoadingStepData(null);
    setSocket(null);
    setSelectedFiles([]);
    setSelectedProject({} as Option);
    setSelectedReport({} as Option);
    setUploadedFiles([]);
    setPendingFiles([]);
    socket?.close();
  };

  useEffect(() => {
    setError(null);
    setQuestion("");
    setCitations([]);
    resetFeedbackState();
    if (socket) socket.close();
    setSocket(null);

    if (conversationIdParam) {
      fetchConversation(conversationIdParam);
    } else {
      setConversationId("");
      resetSession();
    }
  }, [conversationIdParam || location.pathname]);

  useEffect(() => {
    if (newChat && newChat === "1") {
      setLoading(true);
      setIsChatLoading(true);
      setConversationId("");
      resetChat();
      setSearchParams({});
      setEnabledSources(new Set());
      setTimeout(() => {
        setLoading(false);
        setIsChatLoading(false);
      }, 1000);
    }
  }, [newChat, location.search]);

  return { resetChat };
};
